import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import PedomanGCG from './PedomanGCG';
import StrukturGCG from './StrukturGCG';

function PedomanStrukturGCGLayout() {
    const items = [
        { id: 'pedoman-gcg', number: '01', label: 'Pedoman GCG', content: <PedomanGCG /> },
        { id: 'struktur-gcg', number: '02', label: 'Struktur GCG', content: <StrukturGCG /> },
    ];
    return <>
        <Helmet><title>Pedoman & Struktur GCG | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Pedoman dan Struktur GCG PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/pedoman-struktur-gcg" /></Helmet>
        <PageHeader title="Pedoman & Struktur GCG" />
        <CorporateSectionLayout title="Pedoman & Struktur GCG" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default PedomanStrukturGCGLayout;
